'use strict'

const balancedReducer = require('./balanced-reducer')

const defaultOptions = {
  maxChildrenPerNode: 174
}

module.exports = function (reduce, _options) {
  const options = Object.assign({}, defaultOptions, _options)
  return balancedReducer(reduce, options)
}



//////////////////
// WEBPACK FOOTER
// ./~/ipfs-unixfs-engine/src/builder/balanced/index.js
// module id = 485
// module chunks = 0